export default {
  path: '/demo',
  name: 'demo',
  component: () => import(/* webpackChunkName: "demo" */ '@/views/demo'),
  children: [
    {
      path: '/demo/typography',
      name: 'demo.typography-demo',
      component: () =>
        import(
          /* webpackChunkName: "typography-demo" */ '@/views/demo/TypographyDemo.vue'
        )
    }
  ]
}
